import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyB_qxeYLteWpHvVFhspeI7LztScyXhzs2E",
  authDomain: "miyazaki-quiz-event-festival.firebaseapp.com",
  projectId: "miyazaki-quiz-event-festival",
  storageBucket: "miyazaki-quiz-event-festival.firebasestorage.app",
  messagingSenderId: "363137054706",
  appId: "1:363137054706:web:0a600ffadec8d58fca9d6b"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
